import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';

const suites = [
  {
    img: '/images/resource/room-service1-1.jpg',
    title: 'China',
    price: '₦30,000',
    desc: 'Perfect for couples seeking a romantic getaway.',
  },
  {
    img: '/images/resource/room-service1-2.jpg',
    title: 'Canada',
    price: '₦35,000',
    desc: 'Spacious suite ideal for families.',
  },
  {
    img: '/images/resource/room-service1-3.jpg',
    title: 'UK',
    price: '₦40,000',
    desc: 'Equipped with business amenities.',
  },
  {
    img: '/images/resource/room-service1-1.jpg',
    title: 'USA',
    price: '₦70,000',
    desc: 'Ultimate luxury experience.',
  },
];

export default function RoomsSuite() {
  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle
        title="Rooms and Suites"
        breadcrumbs={[{ label: 'Rooms & Suites' }]}
      />
      <section className="room-service-section pt-120 pb-60">
        <div className="auto-container">
          <div className="sec-title text-center">
            <span className="sub-title">LUXURY ROOMS</span>
            <h2>Our Premium Suites</h2>
          </div>
          <div className="row">
            {suites.map((s, i) => (
              <div
                key={i}
                className="room-service-block-one col-lg-6 col-sm-6 wow fadeInUp"
              >
                <div className="inner-box">
                  <div className="image-box">
                    <figure className="image mb-0">
                      <Link to="/room-details">
                        <img src={s.img} alt={s.title} />
                      </Link>
                    </figure>
                  </div>
                  <div className="content-box">
                    <div className="inner-box">
                      <h4 className="title">
                        <Link to="/room-details">{s.title}</Link>
                      </h4>
                      <div className="price">{s.price}/ Night</div>
                    </div>
                    <p>{s.desc}</p>
                    <Link
                      to="/room-details"
                      className="theme-btn btn-style-one mt-2"
                    >
                      <span className="btn-title">Book Now</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
